import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ChecklistEquipamento } from '../classes/ChecklistEquipamento';


@Injectable({
  providedIn: 'root'
})
export class ChecklistEquipamentoService {

  constructor(private http: HttpClient) { }

  route = "ChecklistEquipamento";

  Listar(equipamentoId: number): Observable<any>{
    return this.http.get(`${environment.apiURL}/${this.route}/Listar/${equipamentoId}`)
  }

  ObterPorId(id:number): Observable<any>{
    return this.http.get(`${environment.apiURL}/${this.route}/${id}`)
  }

  Inserir(obj: ChecklistEquipamento): Observable<any>{
    return this.http.post(`${environment.apiURL}/${this.route}`, obj);
  }

  Atualizar(id: number, obj: ChecklistEquipamento): Observable<any>{
    return this.http.put(`${environment.apiURL}/${this.route}/${id}`, obj);
  }

  Excluir(id: number): Observable<any>{
    return this.http.delete(`${environment.apiURL}/${this.route}/${id}`);
  }

}
